module.exports = __webpack_public_path__ + "static/media/partenaire_kennedy.85759d81.jpg";